import React from "react";
import { Link } from "react-router-dom";
import CreateBatch from "../../../Components/Admin/Batch/CreateBatch";
import ListBatch from "../../../Components/Admin/Batch/ListBatch";

const Student = () => {
  return (
    <>
      <main className=" container flex-1 overflow-x-hidden overflow-y-auto">
        <div className="container mx-auto px-6 py-3">
          <h3 className="text-gray-700 text-3xl font-bold">Manage Students</h3>
          <CreateBatch />
          <Link
            to="/admin/all-students"
            className="bg-green-500 text-white active:bg-green-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
            type="button"
          >
            <i className="fa-solid fa-users mr-1"></i> List All Students
          </Link>
          <hr />
          <div className="mt-3">
            <ListBatch />
          </div>
        </div>
      </main>
    </>
  );
};

export default Student;
